export const PROFILE_EN = {
    "record.changes.trigger": "What do you want to change?",
    "record.in_force.since": "In force since {day}",
    "record.in_force.decision": "decision {decision}",
    "gov_sa.gosi.employment_items.title": "Reports to GOSI",
    "gov_sa.gosi.employment_items.empty": "Nothing reported to GOSI about this employee yet.",
    "gov_sa.mudad.employment_lines.title": "Wage protection (Mudad)",
    "gov_sa.mudad.employment_lines.col.run_period": "Month",
    "gov_sa.mudad.employment_lines.col.kind": "File",
    "gov_sa.mudad.employment_lines.col.pay_date": "Pay day",
    "gov_sa.mudad.employment_lines.col.status": "Mudad says",
    "gov_sa.mudad.employment_lines.col.reason": "Why",
    "gov_sa.mudad.employment_lines.kind.salary": "Salary file",
    "gov_sa.mudad.employment_lines.kind.direct_transfer": "Direct transfer",
    "gov_sa.mudad.employment_lines.kind.advance": "Advance",
    "gov_sa.mudad.employment_lines.status.none": "No report yet",
    "gov_sa.mudad.employment_lines.status.pending": "Pending",
    "gov_sa.mudad.employment_lines.status.paid": "Paid",
    "gov_sa.mudad.employment_lines.status.rejected": "Rejected",
    "gov_sa.mudad.employment_lines.note": "Where each salary line stands with Mudad. The amounts and the account stay in the file.",
    "gov_sa.mudad.employment_lines.empty": "This employee is in no salary file yet.",
    "value.type.probation_confirmation": "Probation confirmed",
    "value.type.probation_extension": "Probation extended",
    "value.channel.jadarat": "Jadarat",
    "value.preferred_language.ar": "Arabic",
    "value.preferred_language.en": "English",
    "value.preferred_language.ur": "Urdu",
    "value.preferred_language.hi": "Hindi",
    "value.preferred_language.bn": "Bengali",
    "value.preferred_language.tl": "Filipino",
    "value.preferred_language.id": "Indonesian",
    "value.preferred_language.ne": "Nepali",
    "value.preferred_language.ml": "Malayalam",
    "value.preferred_language.other": "Other",
    "gov_sa.qiwa.employment_attest.title": "Qiwa",
    "gov_sa.qiwa.employment_attest.action.record": "Record the Qiwa documentation",
    "gov_sa.qiwa.employment_attest.field.reference": "Qiwa reference",
    "gov_sa.qiwa.employment_attest.field.done_on": "Documented on",
    "gov_sa.qiwa.employment_attest.field.note": "Note",
    "gov_sa.refusal.qiwa.nothing_to_record": "No contract of this employee waits to be documented on Qiwa.",
    "value.result.waitlisted": "Waiting for a seat",
    "hub.analytics.lede_period": "Counted on the server from the records: {scope:months}, up to {today}",
    "hub.export.not_ready": "Not loaded when the file was made",
    "hub.export.empty": "Nothing to show",
    "forms.requests.col.requester": "Requester",
    "change.field.request.submitter_party_ref": "Requester",
    "documents.types.col.class": "Kind",
    "documents.types.field.class": "Kind of document",
    "documents.types.field.class.help": "What other modules ask for — a residence permit, a passport — whatever this type is called here.",
    "documents.class.identity_card": "Identity card",
    "documents.class.residence_permit": "Residence permit",
    "documents.class.passport": "Passport",
    "documents.class.visa": "Visa",
    "documents.class.work_permit": "Work permit",
    "documents.class.driving_licence": "Driving licence",
    "documents.class.professional_licence": "Professional licence",
    "documents.class.certificate": "Certificate",
    "documents.class.contract": "Contract",
    "documents.class.insurance": "Insurance",
    "documents.class.medical": "Medical",
    "documents.class.other": "Other",
    "documents.refusal.document_class": "That is not a kind of document.",
    "change.field.type.class": "Kind of document",
    "parties.col.register_number": "Register no.",
    "hub.scope.unscoped": "Not narrowed by {scope}: {parts} — their modules answer for all of them",
    "hub.scope.people_unavailable": "Who works in the {scope} chosen could not be told now, so this part is not shown. Choose «All» to see it whole.",
};
export const PROFILE_AR = {
    "record.changes.trigger": "ماذا تريد أن تغيّر؟",
    "record.in_force.since": "ساري منذ {day}",
    "record.in_force.decision": "بقرار {decision}",
    "gov_sa.gosi.employment_items.title": "بلاغات التأمينات الاجتماعية",
    "gov_sa.gosi.employment_items.empty": "لم يُبلَّغ التأمينات بشيء عن هذا الموظّف بعد.",
    "gov_sa.mudad.employment_lines.title": "حماية الأجور (مُدد)",
    "gov_sa.mudad.employment_lines.col.run_period": "الشهر",
    "gov_sa.mudad.employment_lines.col.kind": "الملف",
    "gov_sa.mudad.employment_lines.col.pay_date": "يوم الصرف",
    "gov_sa.mudad.employment_lines.col.status": "ردّ مُدد",
    "gov_sa.mudad.employment_lines.col.reason": "السبب",
    "gov_sa.mudad.employment_lines.kind.salary": "ملف الرواتب",
    "gov_sa.mudad.employment_lines.kind.direct_transfer": "تحويل مباشر",
    "gov_sa.mudad.employment_lines.kind.advance": "سلفة",
    "gov_sa.mudad.employment_lines.status.none": "لا رد بعد",
    "gov_sa.mudad.employment_lines.status.pending": "قيد المعالجة",
    "gov_sa.mudad.employment_lines.status.paid": "مدفوع",
    "gov_sa.mudad.employment_lines.status.rejected": "مرفوض",
    "gov_sa.mudad.employment_lines.note": "أين يقف كل سطر راتب لدى مُدد. المبالغ والحساب تبقى في الملف.",
    "gov_sa.mudad.employment_lines.empty": "لم يدخل هذا الموظّف في ملف رواتب بعد.",
    "value.type.probation_confirmation": "تثبيت بعد التجربة",
    "value.type.probation_extension": "تمديد التجربة",
    "value.channel.jadarat": "جدارات",
    "value.preferred_language.ar": "العربية",
    "value.preferred_language.en": "الإنجليزية",
    "value.preferred_language.ur": "الأردية",
    "value.preferred_language.hi": "الهندية",
    "value.preferred_language.bn": "البنغالية",
    "value.preferred_language.tl": "الفلبينية",
    "value.preferred_language.id": "الإندونيسية",
    "value.preferred_language.ne": "النيبالية",
    "value.preferred_language.ml": "المالايالامية",
    "value.preferred_language.other": "أخرى",
    "gov_sa.qiwa.employment_attest.title": "قوى",
    "gov_sa.qiwa.employment_attest.action.record": "تسجيل التوثيق في قوى",
    "gov_sa.qiwa.employment_attest.field.reference": "مرجع قوى",
    "gov_sa.qiwa.employment_attest.field.done_on": "تاريخ التوثيق",
    "gov_sa.qiwa.employment_attest.field.note": "ملاحظة",
    "gov_sa.refusal.qiwa.nothing_to_record": "لا عقد لهذا الموظّف ينتظر التوثيق في قوى.",
    "value.result.waitlisted": "في الانتظار",
    "hub.analytics.lede_period": "محسوبة على الخادم من السجلات: {scope:months}، حتى {today}",
    "hub.export.not_ready": "لم تكن محمّلة عند إنشاء الملف",
    "hub.export.empty": "لا شيء لعرضه",
    "forms.requests.col.requester": "مقدّم الطلب",
    "change.field.request.submitter_party_ref": "مقدّم الطلب",
    "documents.types.col.class": "النوع العام",
    "documents.types.field.class": "نوع المستند العام",
    "documents.types.field.class.help": "ما تطلبه الوحدات الأخرى — تصريح إقامة، جواز سفر — أيّاً كان اسم هذا النوع هنا.",
    "documents.class.identity_card": "بطاقة هوية",
    "documents.class.residence_permit": "تصريح إقامة",
    "documents.class.passport": "جواز سفر",
    "documents.class.visa": "تأشيرة",
    "documents.class.work_permit": "رخصة عمل",
    "documents.class.driving_licence": "رخصة قيادة",
    "documents.class.professional_licence": "رخصة مهنية",
    "documents.class.certificate": "شهادة",
    "documents.class.contract": "عقد",
    "documents.class.insurance": "تأمين",
    "documents.class.medical": "طبي",
    "documents.class.other": "أخرى",
    "documents.refusal.document_class": "هذا ليس نوعاً من المستندات.",
    "change.field.type.class": "نوع المستند العام",
    "parties.col.register_number": "رقم السجل",
    "hub.scope.unscoped": "لا تُقسَّم حسب {scope}: {parts} — تعرض وحداتها الكل",
    "hub.scope.people_unavailable": "تعذّر الآن معرفة مَن يعمل في {scope} المختار، فلا يُعرض هذا الجزء. اختر «الكل» لتراه كاملاً.",
};
//# sourceMappingURL=i18n-profile.js.map